import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
  ) { }

  canActivate(): boolean {
    const cookieName = 'login-token';

    if (localStorage.getItem(cookieName)) {
      this.userService.user = JSON.parse(window.atob(localStorage.getItem(cookieName)));
    }
    const isLoggedIn = this.userService.user && this.userService.user.token !== undefined && this.userService.user.token !== '';
    if (isLoggedIn) {
      return true;
    } else {
        localStorage.removeItem(cookieName);
      this.router.navigate(['/login']);
      return false;
    }
  }

}
